import { gql } from '@apollo/client';

export const GET_ALL_USERS = gql`
   query GetAllUsers {
      users {
         id
         username
         firstName
         lastName
         email
         phone
         company
         address
         roles
         userType
         isActive
         lastLoginDate
         createdAt
         updatedAt
         profilePicture {
            data
            contentType
         }
      }
   }
`;

export const ADD_USER = gql`
   mutation RegisterUser(
      $input: RegisterUserInput!
   ) {
      registerUser(
         input: $input
      ) {
         token
         user {
            id
            username
            firstName
            lastName
            email
            roles
            userType
            isActive
            createdAt
            updatedAt
         }
      }
   }
`;

export const UPDATE_USER = gql`
   mutation UpdateUserProfile($userId: ID!, $input: UpdateUserProfileInput!) {
      updateUserProfile(userId: $userId, input: $input) {
         id
         username
         firstName
         lastName
         email
         phone
         company
         address
         roles
         isActive
      }
   }
`;

export const DEACTIVATE_USER = gql`
   mutation DeactivateUser($id: ID!) {
      deactivateUser(id: $id) {
         id
         isActive
      }
   }
`;

export const ACTIVATE_USER = gql`
   mutation ActivateUser($id: ID!) {
      activateUser(id: $id) {
         id
         isActive
      }
   }
`;

export const DELETE_USER = gql`
   mutation DeleteUser($id: ID!) {
      deleteUser(id: $id) {
         id
         username
      }
   }
`;

export const GET_USER_DETAILS = gql`
   query GetUserDetails($id: ID!) {
      getUserDetails(id: $id) {
         id
         username
         firstName
         lastName
         email
         phone
         company
         address
         roles
         userType
         isActive
         lastLoginDate
         createdAt
         updatedAt
         lastPasswordChange
         profilePicture {
            data
            contentType
         }
         recentActivities {
            id
            type
            timestamp
            details
         }
         stats {
            totalApplications
            activePermits
            pendingPayments
         }
      }
   }
`;

const UPDATE_USER_MUTATION = gql`
   mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
      updateUserProfile(input: $input) {
         id
         username
         firstName
         lastName
         email
         phone
         company
         address
         roles
         isActive
      }
   }
`;
